import lSportsService from './lSportsService.js';

export default lSportsService;
